import TranslationService from './translation';
import configStore from '../config-store';

const translationService = new TranslationService(configStore, window);

translationService.initialize();

export default translationService;
